// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import { applyParams } from '../LocaleProvider';

/**
 * `Translate` component.
 */
const Translate = ({ component: Tag, content, children, params, unsafe, fallback = null, ...props }, { locale }) => {
    const key = content || children;
    let message = locale && locale.lmsg(key, params, fallback);
    if (typeof message === 'undefined') {
        message = fallback === null ? `[${key}]` : applyParams(fallback, params);
    }

    if (unsafe) {
        props.dangerouslySetInnerHTML = { __html: message };
    } else {
        props.children = message;
    }
    return <Tag {...props} />;
};

Translate.contextTypes = {
    locale: PropTypes.object,
};

Translate.propTypes = {
    /**
     * Translatable content or message key.
     */
    content: PropTypes.string,
    /**
     * Message params
     */
    params: PropTypes.object,
    /**
     * Fallback translation value.
     */
    fallback: PropTypes.string,
    /**
     * Component to render as the root element. Useful when rendering a `Translate` as `<option>`.
     */
    component: PropTypes.string,
    /**
     * @ignore
     */
    unsafe: PropTypes.bool,
    /**
     * @ignore
     */
    children: PropTypes.string,
};

Translate.defaultProps = {
    content: null,
    params: null,
    component: 'span',
    unsafe: null,
    fallback: null,
    children: null,
};

export default Translate;



// WEBPACK FOOTER //
// ./components/Translate/Translate.js